import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const useDateRangePickerStyles = createUseStyles({
  dateRangePicker: {
    height: 40,
    width: isTimeSelectable => (isTimeSelectable ? 330 : 250),
    borderWidth: 1,
    borderColor: '#ddd',
    borderStyle: 'solid',
    borderRadius: 4,
    backgroundColor: '#fff',

    '&.active': {
      borderColor: colors.primary1,
      boxShadow: `0px 0px 0px 1px ${colors.primary1}`
    },

    '&.disabled': {
      opacity: 0.4,
      pointerEvents: 'none'
    }
  },
  customDatePicker: {
    border: 0,
    width: '100%',
    maxWidth: isTimeSelectable => (isTimeSelectable ? 120 : 80),
    margin: '0 0.5rem',
    textAlign: 'center',

    '&:hover': {
      backgroundColor: 'rgba(175, 191, 39, 0.25) !important'
    }
  },
  calendarIcon: {
    padding: '0 10px',
    fontSize: 20,
    borderRight: '1px solid #ddd'
  },
  arrowIcon: {
    fontSize: 12,
    transform: 'translateY(1px)'
  }
})

export { useDateRangePickerStyles }
